module.exports = "// basic.vert\nprecision highp float;\nattribute vec3 positions;\nuniform float aspectRatio;\nattribute vec2 aUV;\n\nvarying vec2 vUv;\nvarying vec2 vUv2;\n\nfloat when_fgt(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\n\nvoid main() {\n\n    gl_Position = vec4(positions, 1.0);\n\n    vUv = aUV;\n\n\n\tvUv2 = mix(\n\t\tvec2(\n\n\t\tvUv.x,\n\t\tvUv.y * 1.0 / aspectRatio + .5 * ( 1. - 1.0 / aspectRatio )\n\t),\n\tvec2(\n\n\t\tvUv.x * aspectRatio / 1.0 + .5 * ( 1. - aspectRatio / 1.0),\n\t\tvUv.y\n\t)\n    ,when_fgt(1.0, aspectRatio));\n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/assets/lib/video/shaders/main.vert
// module id = 550
// module chunks = 3